import { ExecuteDrawerConstants } from './ExecuteDrawer.constants';
import moment from 'moment';

const initialState = {
    selectedTab: { key: 'product', value: 'product' },
    isExecuteDrawerVisible: false,
    drawerTab: '',
    appliedFilters: {
        pageNumber: 1,
        pageSize: 100,
        dateRange: [
            moment(moment().subtract(29, 'days'), 'DD/MM/YYYY').startOf('day'),
            moment(moment(), 'DD/MM/YYYY').endOf('day')
        ]
    }
};

const ExecuteDrawerReducer = (state = initialState, action) => {
    switch (action.type) {
        case ExecuteDrawerConstants.ON_UPDATE_EXECUTE_DRAWER_VISIBILITY:
            return {
                ...state,
                isExecuteDrawerVisible: action.payload
            };

        case ExecuteDrawerConstants.ON_UPDATE_DRAWER_TAB:
            return {
                ...state,
                drawerTab: action.payload
            };

        case ExecuteDrawerConstants.ON_UPDATE_SELECTED_TAB:
            return {
                ...state,
                selectedTab: { ...action.payload }
            };

        case ExecuteDrawerConstants.ON_UPDATE_APPLIED_FILTERS:
            if (action.payload.isReset) {
                delete action.payload.isReset;
                return {
                    ...state,
                    appliedFilters: {
                        ...initialState.appliedFilters,
                        ...action.payload
                    }
                };
            }
            return {
                ...state,
                appliedFilters: {
                    ...state.appliedFilters,
                    ...action.payload,
                    ...(!action?.payload?.pageNumber && {
                        pageNumber: initialState?.appliedFilters?.pageNumber
                    })
                }
            };

        case ExecuteDrawerConstants.ON_RESET_TO_DEFAULT:
            return {
                ...initialState,
                ...action.payload
            };

        default:
            return state;
    }
};

export default ExecuteDrawerReducer;
